import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProductosService } from 'src/app/services/productos.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-productos',
  templateUrl: './productos.component.html',
  styleUrls: ['./productos.component.scss']
})
export class ProductosComponent implements OnInit {
  compuesto: boolean;
  producto: any;
  listado: any;
  listaFiltrada = [];
  cat: string;
  subc: string;
  constructor(private productSvc: ProductosService,
              private router: Router) {
    this.cat = this.productSvc.categoria;
    this.subc = this.productSvc.subcategoria;
    if (this.cat === 'sector') {
      this.compuesto = true;
    } else {
      this.compuesto = false;
    }
  }

  ngOnInit(): void {
    console.log(this.subc);

    if (this.subc) {
      this.cargarListadoProductos();
    } else {
      Swal.fire('Por favor seleccione tipo de productos a visualizar');
      this.router.navigate(['/sellos']);
    }
  }

  cargarListadoProductos(){
    this.productSvc.listaProductosPorCatySub(this.cat, this.subc)
                   .subscribe(res => {
                     this.listado = res;
                     for (const key in this.listado){
                       const prod: any = this.listado[key];
                       for (const k in prod.subcategoria){
                          if (prod.subcategoria[k] === this.subc) {
                          this.listaFiltrada.push(prod);
                        }
                       };
                     };
                   });
  }

  openProduct(producto: any){
    console.log(producto);    
    this.productSvc.prodSelected = producto;
    this.router.navigate([`/producto/${producto.id}`]);
  }



}
